import { router } from "@inertiajs/react"
import { Archive, Bot, Image, X } from "lucide-react"
import { Button } from "@/components/ui/button"

export function ClipsBulkActionBar({
  selectedIds,
  onClear,
  onRequestThumbnails,
}: {
  selectedIds: number[]
  onClear: () => void
  onRequestThumbnails?: (ids: number[]) => void
}) {
  if (selectedIds.length === 0) return null

  function handleGetThumbnails() {
    if (onRequestThumbnails) {
      onRequestThumbnails(selectedIds)
      onClear()
    } else {
      router.post("/clips/bulk_extract_thumbnails", { clip_ids: selectedIds }, {
        preserveScroll: true,
        onSuccess: onClear,
      })
    }
  }

  function handleMarkForEnrichment() {
    router.post("/clips/bulk_mark_for_enrichment", { clip_ids: selectedIds }, {
      preserveScroll: true,
      onSuccess: onClear,
    })
  }

  function handleCancelEnrichment() {
    router.post("/clips/bulk_cancel_enrichment", { clip_ids: selectedIds }, {
      preserveScroll: true,
      onSuccess: onClear,
    })
  }

  function handleDeprecate() {
    if (!window.confirm(`Deprecate ${selectedIds.length} clip${selectedIds.length === 1 ? "" : "s"}?`)) return
    router.post("/clips/bulk_deprecate", { clip_ids: selectedIds }, {
      preserveScroll: true,
      onSuccess: onClear,
    })
  }

  return (
    <div className="inline-flex items-center gap-2 rounded-md bg-accent-faded px-3 py-1">
      <span className="text-sm text-ink-display">
        <strong>{selectedIds.length}</strong> clip{selectedIds.length === 1 ? "" : "s"} selected
      </span>
      <Button size="sm" variant="primary" onClick={handleGetThumbnails}>
        <Image className="mr-1 h-3.5 w-3.5" />
        Get thumbnails ({selectedIds.length})
      </Button>
      <Button size="sm" variant="secondary" onClick={handleMarkForEnrichment}>
        <Bot className="mr-1 h-3.5 w-3.5" />
        Queue for enrichment ({selectedIds.length})
      </Button>
      <Button size="sm" variant="ghost" onClick={handleCancelEnrichment}>
        <X className="mr-1 h-3.5 w-3.5" />
        Cancel enrichment ({selectedIds.length})
      </Button>
      <Button size="sm" variant="ghost" onClick={handleDeprecate}>
        <Archive className="mr-1 h-3.5 w-3.5" />
        Deprecate ({selectedIds.length})
      </Button>
      <button
        type="button"
        onClick={onClear}
        aria-label="Clear selection"
        className="inline-flex h-6 w-6 cursor-pointer items-center justify-center rounded-md text-ink-muted hover:bg-page hover:text-ink-display"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  )
}
